import { css, html, LitElement } from "lit"
import { customElement, property } from "lit/decorators.js"

@customElement("remote-list")
class RemoteList extends LitElement {
  static styles = css`
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li:before {
      content: "+";
      margin-right: 4px;
    }

    div {
      max-height: 10vw;
      overflow-y: auto;
    }
  `

  @property()
  url: string

  @property({type: Array})
  items = []

  connectedCallback() {
    super.connectedCallback()

    fetch(this.url).then(res => res.json()).then(items => this.items = items)
  }

  render() {
    return html`
      <div>
        <ul>
          ${this.items.map(item => html`<li>${item}</li>`)}
        </ul>
      </div>
    `
  }
}